<template>
  <div class="h5-bottom-form">
    <div class="form-border">
      <div class="line">
        <div class="input-border" :class="[(isClick && name == '') || name == '请输入您的姓名(中文)' ? 'active' : '']">
          <img class="input-icon" :src="require('@/assets/images/input-icon-name.svg')" />
          <span class="after-icon"></span>
          <input v-model="name" type="text" class="userName" placeholder="您的姓名" @focus="clearData(0)" @blur="onfousFun()" />
        </div>
      </div>
      <div class="line">
        <div class="input-border" :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active' : '']">
          <img class="input-icon" :src="require('@/assets/images/input-icon-company.svg')" />
          <span class="after-icon"></span>
          <input v-model="companyName" type="text" class="companyName" placeholder="公司名称" @focus="clearData(1)" @blur="onfousFun()" />
        </div>
      </div>
      <div class="line">
        <div class="input-border" :class="[(isClick && phoneNumber == '') || phoneNumber == '请输入您的联系方式' ? 'active' : '']">
          <img class="input-icon" :src="require('@/assets/images/input-icon-phone.svg')" />
          <span class="after-icon"></span>
          <input
            v-model="phoneNumber"
            id="mobile"
            type="text"
            class="mobile"
            placeholder="手机号码"
            @focus="clearData(2)"
            @blur="onfousFun()"
          />
        </div>
      </div>

      <div class="line">
        <div class="code-box input-border" :class="[(isClick && phoneCode == '') || phoneCode == '请输入验证码' ? 'active' : '']">
          <input
            v-model="phoneCode"
            maxlength="6"
            type="text"
            class="code-input form-control code no_border"
            placeholder="短信验证码"
            @focus="clearData(3)"
            @blur="onfousFun()"
          />

          <span
            :class="[codeName == '获取验证码' ? 'active_c1' : 'active_c']"
            class="code-btn"
            id="code-btn"
            @click="handleFetchCodeClick()"
          >
            <span class="code-bar"></span>
            <span>{{ codeName }}</span>
          </span>
        </div>
      </div>
      <div class="line agreement-line" v-if="userAgreement.enable">
        <label class="wrapper">
          <input type="checkbox" v-model="agreement" />
          <span>我已阅读并同意<span style="color:#1890ff;" @click.prevent="showProtocal">《隐私政策》</span></span>
        </label>
        <div v-show="showErrorTip" class="error-tip">请先阅读并同意隐私政策</div>
      </div>
      <div class="line bot-container" v-if="showManMachineSlide">
        <div id="man-machine-slide"></div>
      </div>
    </div>

    <div class="submit-btn" :class="changeBtnBg ? 'bg_active1' : 'bg_active0'" @click="handleSendInfoBtnClick">
      <div class="inner">
        <img :src="require('@/assets/images/icon-submit-btn.svg')" alt="submit" />
        <span>提交试用信息</span>
      </div>
    </div>

    <!-- 阅读协议 -->
    <Protocol :visible.sync="protocolVisible" :type="protocolType" />
  </div>
</template>

<script>
import formMixin from '../mixins/form.js'

export default {
  mixins: [formMixin],
  components: {
    Protocol: () => import('@/components/Protocol.vue'),
  },
  props: {
    show: Boolean,
    showManMachineSlide: Boolean,
    landingPageName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isH5: true,
      protocolVisible: false,
      protocolType: 'privacy',
      showErrorTip: false,
    }
  },
  watch: {
    show(val) {
      if (!val) this.reset()
    },
  },
  methods: {
    showProtocal() {
      this.protocolVisible = true
    },
  },
}
</script>

<style lang="less" scoped>
.h5-bottom-form {
  font-size: 16px;
  padding: 21px 20px 0;

  .form-border {
    margin-bottom: 18px;
  }

  a {
    display: block;
    text-decoration: none;
  }

  .line {
    width: 100%;
    height: 55px;
    position: relative;
    margin: 0 auto;

    .input-border {
      height: 100%;
      border: 1px solid #d5d5d5;
      border-bottom: 0;
      position: relative;
      z-index: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &.code-box {
        border-bottom: 1px solid #d5d5d5;
      }

      &.active {
        border: 1px solid #e61717;
        color: #e61717;
        z-index: 1;

        input {
          color: #e61717;
        }
      }

      .input-icon {
        display: inline-block;
        width: 10px;
        height: 15px;
        flex-shrink: 0;
        margin-left: 13px;
      }

      .after-icon,
      .code-bar {
        display: inline-block;
        height: 13px;
        border: 0;
        border-right: 1px solid #e3e3e3;
        color: #e3e3e3;
        margin: 0 10px;
      }

      .code-bar {
        margin-right: 30px;
        vertical-align: middle;
      }
    }

    input {
      flex-grow: 1;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      display: block;
      padding: 0;
      color: #333;
      outline: 0;
      border: 0;

      &::placeholder {
        color: #d6d6d6;
      }
    }

    .form-control.code {
      width: 170px !important;
      padding-left: 20px !important;
    }

    .active_c {
      color: #ccc;

      &1 {
        color: #ff6d6d;
      }
    }
  }

  .code-box {
    position: relative;
    height: 100%;
    border: 1px solid #d5d5d5;
    margin-top: -1px;

    .no_border {
      border: 0;
      box-shadow: none !important;

      &:focus {
        box-shadow: none;
        border-color: #fa485a;
      }
    }
  }

  .code-btn {
    min-width: 140px;
    height: 100%;
    border-radius: 2px;
    position: absolute;
    text-align: right;
    right: 20px;
    top: 0;
    bottom: 0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    line-height: 55px;

    &.disabled {
      background: #ccc;
      color: #fff;
    }
  }

  .bg_active0 {
    background: #e61717 !important;
  }
  .bg_active1 {
    background: rgba(230, 23, 23, 0.5) !important;
  }

  .btn_zc {
    width: 300px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #297acc;
  }

  .try-tit {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    color: #333;
    line-height: 25px;
    font-weight: 700;
    margin-bottom: 17px;
    text-align: center;
  }

  .btn-try {
    width: 300px;
    height: 42px;
    border-radius: 3px;
    margin: 0 auto 17px;
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    color: #fff;
  }

  .bot-container {
    height: auto;
  }

  .submit-btn {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 43px;
    background: #e61717;
    font-size: 12px;
    border-radius: 4px;
    color: #fff;
    padding: 0 100px;
    margin-bottom: 20px;

    .inner {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    img {
      width: 30px;
      margin-right: 6px;
    }
  }
  .agreement-line {
    height: auto;
    color: #000;
    padding: 6px 0;
    .wrapper {
      display: flex;
      align-items: center;
    }
    input {
      width: 14px;
      height: 14px;
      display: inline-block;
      flex-grow: 0;
    }
    span {
      font-size: 13px;
      margin-left: 6px;
    }
    a {
      display: inline-block;
      font-size: 13px;
      color: #1890ff;
    }
    .error-tip {
      font-size: 12px;
      color: red;
      position: absolute;
      bottom: -12px;
    }
  }
}
</style>

<style lang="less">
@import '../mixins/bot.less';

.h5-bottom-form {
  .bot_slide_h5(
    @slideHeight: 55px,
    @okIconColor: #37c780,
    @placeholderColor: #1a1a1a,
    @placeholderFontWeight: 400,
    @arrowSize: 14px,
    @arrowColor: #979797
  );
}
</style>
